import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';

const nav = [
  ['/', 'Overview'],
  ['/companies', 'Companies'],
  ['/events', 'Signals'],
  ['/jobs', 'Jobs'],
  ['/research', 'Stealth watch'],
  ['/desk', 'Review desk'],
] as const;

export function Layout() {
  // The boundary is reset by navigation, so a view that broke on one record
  // does not keep its error panel after the reader has moved elsewhere.
  const { pathname } = useLocation();
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <NavLink to="/" className="brand">
          <span className="brand__mark">A</span>
          <span><strong>Axiom</strong><small>Radar</small></span>
        </NavLink>
        <nav>{nav.map(([to, name]) => <NavLink key={to} to={to} end={to === '/'}>{name}</NavLink>)}</nav>
        <div className="sidebar__note"><span className="live-dot" />Evidence-backed intelligence</div>
      </aside>
      <main className="main-content">
        <ErrorBoundary resetKey={pathname}><Outlet /></ErrorBoundary>
      </main>
    </div>
  );
}
